import axios from "axios";
import { toast } from "react-toastify";

export const FETCH_INVOICES_REQUEST = "FETCH_INVOICES_REQUEST";
export const FETCH_INVOICES_SUCCESS = "FETCH_INVOICES_SUCCESS";
export const FETCH_INVOICES_FAILURE = "FETCH_INVOICES_FAILURE";
export const GENERATE_INVOICE_SUCCESS = "GENERATE_INVOICE_SUCCESS";

export const fetchInvoices = (params) => async (dispatch, getState) => {
  dispatch({ type: FETCH_INVOICES_REQUEST });
  
  try {
    const { AuthReducer: { auth } } = getState();
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined && value !== null && value !== '')
    );
    
    const response = await axios.get("/api/admin/v1/invoices", {
      headers: { Authorization: `Bearer ${auth?.token}` },
      params: cleanParams,
    });

    dispatch({
      type: FETCH_INVOICES_SUCCESS,
      payload: {
        invoices: response.data.invoices || [],
        count: response.data.totalCount || 0
      }
    });
  } catch (error) {
    dispatch({
      type: FETCH_INVOICES_FAILURE,
      payload: error.response?.data?.message || "Failed to fetch invoices"
    });
    toast.error("Failed to fetch invoices");
  }
};

export const generateInvoice = (bookingId) => async (dispatch, getState) => {
  try {
    const { AuthReducer: { auth } } = getState();
    const response = await axios.post(`/api/admin/v1/generate-invoice/${bookingId}`, {}, {
      headers: { Authorization: `Bearer ${auth?.token}` },
    });
    
    dispatch({
      type: GENERATE_INVOICE_SUCCESS,
      payload: response.data.invoice
    });
    
    toast.success("Invoice generated successfully");
  } catch (error) {
    toast.error("Failed to generate invoice");
  }
};